import { render } from "./transferOwnershipModal.vue?vue&type=template&id=2d0b5f56&scoped=true"
import script from "./transferOwnershipModal.vue?vue&type=script&lang=js"
export * from "./transferOwnershipModal.vue?vue&type=script&lang=js"

import "./less/transferOwnership.less?vue&type=style&index=0&id=2d0b5f56&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0b5f56"]])

export default __exports__